import { render, staticRenderFns } from "./CurrentPageReport.vue?vue&type=template&id=780bcfee&"
import script from "./CurrentPageReport.vue?vue&type=script&lang=js&"
export * from "./CurrentPageReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports